module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"create_new_button.label":"Criar novo"},"en":{"create_new_button.label":"Create new"}}')
  delete Component.options._Ctor
}
